module.exports = __webpack_public_path__ + "media/images/bg-title-results-6340dd0b4cd6fcec434dad54cd6d8a71.png";